module.exports = __webpack_public_path__ + "images/andrew-clark.jpg?v=d0c1b4e15146f515091bcf9f78353d08";